/**
 * createSubscriber.js
 * Written by: Alex Kasemir
 */

import { setStorage } from '@minerva-analytics/pantheon';

import request from '../../../request/actions';


export const createSubscriberStart = () => ({
  type: `CREATE_SUBSCRIBER_START`,
});

export const createSubscriberSuccess = () => ({
  type: `CREATE_SUBSCRIBER_SUCCESS`,
});

export const createSubscriberFailure = () => ({
  type: `CREATE_SUBSCRIBER_FAILURE`,
});

/**
 * Description of the createSubscriber action
 */
export const createSubscriber = (data) => {
  return (dispatch) => {
    dispatch(createSubscriberStart());

    return new Promise((resolve, reject) => {
      dispatch(request(`/subscribe/`, `POST`, data, null))
        .then((response) => {
          dispatch(createSubscriberSuccess());
          setStorage({ key: `subscribed`, value: `true` });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch(createSubscriberFailure());
          reject(e.response.data);
        });
    });
  };
};

export default createSubscriber;
